import { ChildrenAnalyzerError } from "../ChildrenAnalyzerError.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _BranchNode = class {
  constructor(factory, componentOrReducer, options) {
    __publicField(this, "specification");
    __publicField(this, "options");
    if (typeof factory !== "function") {
      this.specification = {
        type: "declarationSite",
        factoryMethodName: factory,
        childrenRepresentationReducer: componentOrReducer
      };
    } else if (typeof factory === "function") {
      this.specification = {
        type: "useSite",
        factory,
        ComponentType: componentOrReducer
      };
    } else {
      throw new ChildrenAnalyzerError("Invalid arguments");
    }
    this.options = {
      ..._BranchNode.defaultOptions,
      ...options
    };
  }
};
let BranchNode = _BranchNode;
__publicField(BranchNode, "defaultOptions", {
  childrenAreOptional: false,
  childrenAbsentErrorMessage: "Component must have children!"
});
export {
  BranchNode
};
//# sourceMappingURL=BranchNode.js.map
